<!-- Accordion.vue -->
<template>
    <div>
        <div class="accordion">
            <div v-for="(item, index) in items" :key="index" class="accordion-item">
                <div @click="toggleAccordion(index)" class="accordion-title btn-indigo">
                    {{ item.title }}
                </div>
                <div v-if="activeIndex === index" class="accordion-content">
                    <slot name="content-{{index}}"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Accordion",
    props: {
        items: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            activeIndex: null
        };
    },
    methods: {
        toggleAccordion(index) {
            this.activeIndex = this.activeIndex === index ? null : index;
        }
    }
};
</script>
